/**
 * @generated SignedSource<<b471391944843cb99cc2be0564e28f12>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type JiraFormattingMultipleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "HAS_ANY_OF" | "%future added value";
export type JiraFormattingNoValueOperator = "IS_EMPTY" | "IS_NOT_EMPTY" | "%future added value";
export type JiraFormattingSingleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "DOES_NOT_EQUAL" | "EQUALS" | "GREATER_THAN" | "GREATER_THAN_OR_EQUALS" | "IS" | "IS_AFTER" | "IS_BEFORE" | "IS_NOT" | "IS_ON_OR_AFTER" | "IS_ON_OR_BEFORE" | "LESS_THAN" | "LESS_THAN_OR_EQUALS" | "%future added value";
export type JiraFormattingTwoValueOperator = "IS_BETWEEN" | "IS_NOT_BETWEEN" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type useRowColor_project$data = {
  readonly conditionalFormattingRules: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly expression: {
          readonly fieldId?: string;
          readonly multipleValueOperator?: JiraFormattingMultipleValueOperator;
          readonly noValueOperator?: JiraFormattingNoValueOperator;
          readonly singleValueOperator?: JiraFormattingSingleValueOperator;
          readonly twoValueOperator?: JiraFormattingTwoValueOperator;
          readonly value?: string;
        };
        readonly formattingColor: {
          readonly colorKey: string | null | undefined;
          readonly id: string | null | undefined;
        };
        readonly id: string;
      } | null | undefined;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly " $fragmentType": "useRowColor_project";
};
export type useRowColor_project$key = {
  readonly " $data"?: useRowColor_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"useRowColor_project">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v1 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "useRowColor_project",
  "selections": [
    {
      "args": [
        {
          "kind": "Literal",
          "name": "first",
          "value": 20
        }
      ],
      "concreteType": "JiraFormattingRuleConnection",
      "kind": "LinkedField",
      "name": "conditionalFormattingRules",
      "plural": false,
      "selections": [
        {
          "concreteType": "JiraFormattingRuleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "concreteType": "JiraFormattingRule",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "name": "expression",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": "singleValueOperator",
                          "kind": "ScalarField",
                          "name": "operator"
                        },
                        {
                          "kind": "ScalarField",
                          "name": "value"
                        }
                      ],
                      "type": "JiraFormattingSingleValueOperand"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": "twoValueOperator",
                          "kind": "ScalarField",
                          "name": "operator"
                        }
                      ],
                      "type": "JiraFormattingTwoValueOperand"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": "multipleValueOperator",
                          "kind": "ScalarField",
                          "name": "operator"
                        }
                      ],
                      "type": "JiraFormattingMultipleValueOperand"
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/),
                        {
                          "alias": "noValueOperator",
                          "kind": "ScalarField",
                          "name": "operator"
                        }
                      ],
                      "type": "JiraFormattingNoValueOperand"
                    }
                  ]
                },
                {
                  "concreteType": "JiraColor",
                  "kind": "LinkedField",
                  "name": "formattingColor",
                  "plural": false,
                  "selections": [
                    (v1/*: any*/),
                    {
                      "kind": "ScalarField",
                      "name": "colorKey"
                    }
                  ]
                },
                (v1/*: any*/)
              ]
            }
          ]
        }
      ],
      "storageKey": "conditionalFormattingRules(first:20)"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "5ef2f936003ebb0c663a9f53d336485f";

export default node;
